import {
  FETCH_FRANCHISE,
  RESET_FRANCHISE,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const getFranchiseLocationsData = (franchise_locations) => {
  let count = 0;
  let obj = {};
  for (let i = 0; i < franchise_locations.length; i++) {
    count++;
    if (obj[franchise_locations[i].state_id]) {
      obj[franchise_locations[i].state_id]["city"].push({
        ...franchise_locations[i].City,
        nodeId: count,
      });
    } else {
      obj[franchise_locations[i].state_id] = {
        state: { ...franchise_locations[i].State, nodeId: count },
      };
      count++;
      obj[franchise_locations[i].state_id]["city"] = [
        { ...franchise_locations[i].City, nodeId: count },
      ];
    }
  }
  return obj;
};

const franchiseViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FRANCHISE:
      let temp = JSON.parse(JSON.stringify(action.payload));
      temp["franchise_locations_data"] = getFranchiseLocationsData(
        temp["franchise_locations"]
      );
      return { data: temp };
    case RESET_FRANCHISE:
      return initialState;
    default:
      return state;
  }
};

export default franchiseViewReducer;
